import React, { useState, useEffect } from "react"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import CLOSEIcon from "../../../stylesheets/images/icons/icon-close.svg"
import * as E from '../../../elementor'

interface Props {
  customNavBanner?: E.Section,
  onBannerClose: () => void
}

const NavBanner: React.FC<Props> = ({ onBannerClose, customNavBanner }) => {
  const [showBanner, setShowBanner] = useState(true)
  const displayCustomNavBanner = customNavBanner !== undefined
  const { textEditor = [], button = [] } = displayCustomNavBanner ? E.collect(customNavBanner) : {}
  const bannerClasses = customNavBanner?.cssClasses ? customNavBanner.cssClasses.split(' ') : []
  const bannerDismissable = bannerClasses.includes('close')
  const bannerColors = bannerClasses.filter(className => className !== 'close')
  const customBannerColor = !!bannerColors.length ? bannerColors[0] : 'amethist'
  const hasLink = !!button[0]

  useEffect(() => {
    // Check if the user has already dismissed the banner
    if (typeof window !== 'undefined') {
      const isBannerClosed = localStorage.getItem("newBannerClosed") === "true"
      if (isBannerClosed) {
        setShowBanner(false)
      }
    }
  }, [])

  const handleCloseBanner = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation()
    setShowBanner(false)
    if (typeof window !== 'undefined') localStorage.setItem("newBannerClosed", "true")
    onBannerClose()
  }

  const handleBannerClick = () => {
    if (!hasLink || typeof window === 'undefined') return

    window.open(button[0].link)
  }

  if (!showBanner) return <></>
  return (
    <div className="cookie-banner-container" style={hasLink ? { cursor: 'pointer' } : {}} onClick={handleBannerClick}>
      <div className="cookie-banner" data-theme={customBannerColor}>
        <p>
          { textEditor[0]?.text() ?? 'Are you a psychiatric provider looking for full-time opportunities?' }
          {hasLink && (
            <span>
              <AniLink target='_blank' aria-label="Home" fade to={button[0].link ?? "https://jobs.ashbyhq.com/rula"} className="learn-more-link">
                { button[0].text ?? 'Learn more.' }
              </AniLink>
            </span>
          )}
        </p>
        {bannerDismissable && (
          <button onClick={handleCloseBanner} className="close-button">
            <img src={CLOSEIcon} alt="Close" />
          </button>
        )}
      </div>     
    </div>
  )
}

export default NavBanner
